<p *ngIf="fieldDescription" class="mb-0 mt-2">
  {{ fieldDescription }}{{ getRequired() ? '*' : '' }}
</p>
<mat-form-field *ngIf="!readonly" appearance="outline"
  floatLabel="always" class="w-100 textarea-field" [ngClass]="{ 'no-label': hideLabel }">
  <mat-label>
    {{ labelOverride || fgInfo?.label
    }}{{ (formControl && formControl['condrequired']) || fgInfo?.required ? '*' : '' }}
    <mat-icon
      [hidden]="!tooltipText"
      [matTooltip]="tooltipText"
      [matTooltipPosition]="'after'"
      [attr.aria-label]="'Tooltip: ' + tooltipText"
      tabindex="0"
    >
      help
    </mat-icon>
  </mat-label>
  <textarea
    matInput
    cdkTextareaAutosize
    #autosize="cdkTextareaAutosize"
    [attr.data-automation-id]="dataAutomationId"
    [cdkAutosizeMinRows]="minRows"
    cdkAutosizeMaxRows="10"
    [required]="fgInfo?.required"
    [placeholder]="placeholder"
    [formControl]="formControl"
    [maxlength]="fgInfo?.maxLength"
    [value]="valueOverride || formControl?.value || ''"
  ></textarea>
  <mat-hint>{{ hint }}</mat-hint>
  <mat-hint *ngIf="showCharacterCount" align="end">
    <span class="visually-hidden">Character count</span>
    <span *ngIf="fgInfo?.maxLength">
      {{ formControl.value ? formControl.value.length : 0 }} / {{ fgInfo.maxLength }}
    </span>
  </mat-hint>
  <!-- <mat-error *ngFor="let errorDefinition of errorDefinitions">
    <ng-container *ngIf="formControl?.touched && errorDefinition.showFunction()">
      {{ errorDefinition.errorMessage(formControl) }}
    </ng-container>
  </mat-error> -->
  <!-- <ng-container *ngFor="let errorDefinition of errorDefinitions">
    <mat-error *ngIf="formControl?.touched && errorDefinition.showFunction() && errorDefinition.errorMessage(formControl)">
      {{ errorDefinition.errorMessage(formControl) }}
    </mat-error>
  </ng-container> -->
  <mat-error *ngIf="errorDefinitions?.length">
    <ng-container *ngFor="let errorDefinition of errorDefinitions">
      <span *ngIf="formControl?.touched && errorDefinition.showFunction() && errorDefinition.errorMessage(formControl)"> {{ errorDefinition.errorMessage(formControl) }}</span>
    </ng-container>
  </mat-error>
</mat-form-field>
<ng-container *ngIf="readonly">
  <mat-form-field
    appearance="outline"
    class="no-underline w-100"
    floatLabel="always"
    [ngClass]="{ 'read-only': readonly, 'no-label': hideLabel }"
  >
    <mat-label>{{ labelOverride || fgInfo?.label }}</mat-label>
    <textarea
      readonly
      matInput
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      cdkAutosizeMinRows="1"
      [attr.data-automation-id]="dataAutomationId"
      [cdkAutosizeMaxRows]="null"
      [value]="showTrimmedText ? trimmedText : (valueOverride || formControl?.value)"
      class="mat-form-field-disabled"
      tabindex="-1"
    ></textarea>
  </mat-form-field>
  <p *ngIf="showTrimmedText && noteIsLong">
    <span class="show-more" (click)="showTrimmedText = false">See more</span>
  </p>
  <p *ngIf="!showTrimmedText && noteIsLong">
    <span class="show-more" (click)="showTrimmedText = true">See less</span>
  </p>
</ng-container>
